"use strict";
// --------------------------------------------------
// MEDICAL CONDITIONS HELPER
// Format the list of medical conditions
// --------------------------------------------------
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.medicalConditions = void 0;
// Require packages
const compact_1 = __importDefault(require("lodash/compact"));
function medicalConditions(data) {
    let output = [];
    const conditions = {
        aids_hiv: 'AIDS/HIV',
        cancer: 'Cancer',
        diabetes: 'Diabetes',
        heart_attack: 'Heart Attack',
        pulmonary_disease: 'Pulmonary Disease',
        stroke: 'Stroke',
    };
    if (data) {
        output = Object.keys(data).map((key) => {
            if (data[key]) {
                return conditions[key];
            }
            else {
                return '';
            }
        });
    }
    return (0, compact_1.default)(output).join(', ');
}
exports.medicalConditions = medicalConditions;
